import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslationDirective } from '../../../shared/translation-directive';

@Component({
  selector: 'upu-access-restricted',
  imports: [TranslationDirective, MatButtonModule, RouterLink, MatIcon],
  host: {
    class:
      'min-h-[calc(100vh-36px)] pt-16 flex flex-col items-center justify-center ',
  },
  templateUrl: './access-restricted.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessRestricted {
  private readonly location = inject(Location);

  protected goBack(): void {
    this.location.back();
  }
}
